<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-select ttLabel="portal_user" [(ttModel)]="edit.portal_user_keyno" [ttData]="selectListPortalUsers" ttDataId="portal_user_keyno" ttDataName="user_name"></tt-select>
        <tt-select ttLabel="location" [(ttModel)]="edit.stocklocation_keyno" [ttData]="selectListStockLocations" ttDataId="item_id" ttDataName="item_name"></tt-select>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
